import { gql } from '@apollo/client';

export const SUMMARIZE_TEXT_MUTATION = gql`
  mutation summarizeText(
    $organizationId: String!
    $config: ContentGenerationInput!
  ) {
    summarizeText(organizationId: $organizationId, config: $config) {
      ... on TextGenerated {
        suggestions {
          content
        }
      }
      ... on CommonError {
        code
        success
        message
        error
      }
    }
  }
`;
